import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import swal from "sweetalert2";
import * as xlsx from 'xlsx';
import { Company } from 'src/app/models/company';
import { environment } from 'src/environments/environment';
import { AccessService } from '../../services/access.service';
import { Client } from 'src/app/models/client';
import { ClientService } from 'src/app/services/client.service';
import { CompanyService } from '../../services/company.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Representative } from 'src/app/models/representative';
import { RepresentativeService } from 'src/app/services/representative.service';

@Component({
  selector: 'app-representative',
  templateUrl: './representative.component.html',
  styleUrls: ['./representative.component.scss'],
  providers: [UtilsService, ClientService, AccessService, CompanyService, RepresentativeService]
})
export class RepresentativeComponent implements OnInit {
  // MODELS VARIABLE
  public client = {} as Client;
  public representative = {} as Representative;
  public company = {} as Company;
  public userCode: number;
  public storeCode: number;
  public companyCode: number;
  public isEdit: boolean;
  public isDisabled: boolean;
  public noCredit: boolean;
  public settings = {
    columns: {
      NameRepresentative: {
        title: 'Nombre Representante'
      },
      NationalityRepresentative: {
        title: 'Nacionalidad'
      },
      NumberIdRepresentative: {
        title: 'No. Identificación'
      },
      FiscalAddressRepresentative: {
        title: 'Dirección Fiscal'
      },
      AddressDriverRepresentative: {
        title: 'Dirección Conductor'
      },
      TypeVehicle: {
        title: 'Tipo Vehículo'
      },
      BrandVehicle: {
        title: 'Marca Vehículo'
      },
      AdditionalVehicle: {
        title: 'Color Vehículo'
      },
      ModelVehicle: {
        title: 'Modelo Vehículo'
      },
      NumberIdVehicle: {
        title: 'No. Identificación Vehículo'
      }
    }
  };
  public url: string;
  loading;

  // VARIABLE FOR DATA TABLE
  public test: any = `<button (click)="onSelect($event)">Click me</button>`;
  public entries: number = 10;
  public selected: any[] = [];
  public temp = [];
  public activeRow: any;
  public clientList: Client[] = new Array();
  public representativeList: Representative[] = new Array();

  // VARIABLE FOR SELECT 
  public categoryList: any[] = new Array();
  public selectedItems = [];
  public dropdownSettings = {};

  public tipoCliente: number;

  constructor(
    private cdref: ChangeDetectorRef,
    private _utilsService: UtilsService,
    private _accessService: AccessService,
    private _clientService: ClientService,
    private _companyService: CompanyService,
    private _representativeService: RepresentativeService
  ) { 
    this.url = environment.url;
    //this.url = 'http://localhost:4200/';
  }

  async ngOnInit() {
    // GET ID USER & ID COMPANY
    const _data = JSON.parse(localStorage.getItem('data'));
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;

    // SET VARIABLE
    this.isEdit = false;
    this.noCredit = true;
    this.isDisabled = false;

    this.representative.TypeVehicle = "VEHICULO";
    this.representative.AdditionalVehicle = "ARGO";
    this.representative.NationalityRepresentative = "PARAGUAYO";

    // LOAD INFORMATION
    this.getAll();
    await this.getCompany(this.companyCode);
    //this.selectedItems = [{ 'id': 1, 'itemName': 'Tipo A' }]
  }

  ///////////////////////COMPANY///////////////////////
  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  ///////////////////////FUNCTION FOR TABLE///////////////////////
  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    let val = $event.target.value.toLowerCase(); 
    this.temp = this.representativeList.filter(function (d) {

      for (var key in d) {
        if (d[key] !== null) {
          if (d[key].toString().toLowerCase().indexOf(val) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  onActivate(event) {
    this.activeRow = event.row;
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ///////////////////////FUNCTION FOR SELECT///////////////////////  
  getSelectSetting(selected) {
    Object.keys(selected).length > 0 ? this.selectedItems = [selected] : '';

    this.dropdownSettings = {
      singleSelection: true,
      text: "Seleccione...",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: ""
    };
  };

  getClientCategory() {
    return this._clientService.getAllClientCategory().then(
      response => {
        if (response.result) {
          response.records.forEach(e => {
            this.categoryList.push({
              id: e.clientCategoryCode,
              itemName: e.clientCategoryName
            });
          });

        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  onItemSelect(item: any) {
    this.client.clientCategory = item.id;
  }

  ///////////////////////CRUD///////////////////////
  // GET ALL REPRESENTANTIVE
  getAll() {
    this.loading = true;
    return this._representativeService.getAll().then(
      response => {
        if (response.result) {
          this.representativeList = response.records;
          this.temp = this.representativeList;
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  // GET ALL CLIENT BY COMPANY
  getAllByCompany() {
    this.loading = true;
    return this._representativeService.getAll().then(
      response => {
        if (response.result) {
          console.log(response.records);
          this.representativeList = response.records;
          this.temp = this.representativeList;
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  // GET ONE CLIENT
  viewFunction($event) {
    $event.preventDefault();

    swal.fire({
      title: "Empresa:",
      html:
        '<div class="text-left">' +
        '<b>Nombre: </b>' + this.activeRow.clientName + '<br>' +
        '<b>Teléfono: </b>' + this.activeRow.clientPhone + '<br>' +
        '<b>Teléfono: </b>' + this.activeRow.clientPhone2 + '<br>' +
        '<b>Correo: </b>' + this.activeRow.clientEmail + '<br>' +
        '<b>Dirección: </b>' + this.activeRow.clientAddress + '<br></div>',
      customClass: {
        confirmButton: "btn btn-success",
      },
      width: 650,
      confirmButtonText: "Aceptar",
      buttonsStyling: false
    })
  }

  onChangeTypeClient(event) {    
    this.client.clientType = event;
    this.tipoCliente = event;
    console.log('Tipo identificación', this.tipoCliente);
  }

  onChangeTypeRUC(event) {
    console.log('Dirección Seleccionada', event);

    if (event == 1) {
      this.representative.FiscalAddressRepresentative = "CALLE MARISCAL FRANCISCO SOLANO LÓPEZ 2732 - BARRIO GENERA DÍAZ";
      this.representative.AddressDriverRepresentative = "CALLE MARISCAL FRANCISCO SOLANO LÓPEZ 2732 - BARRIO GENERA DÍAZ";
    } else if (event == 2) {
      this.representative.FiscalAddressRepresentative = "CALLE ANDRÉS ROJAS, EDIF. WORLD TRADE CENTER, PISO 2 OFICINA C - BARRIO PABLO ROJAS";
      this.representative.AddressDriverRepresentative = "CALLE ANDRÉS ROJAS, EDIF. WORLD TRADE CENTER, PISO 2 OFICINA C - BARRIO PABLO ROJAS";
    } else if (event == 3) {
      this.representative.FiscalAddressRepresentative = "AV. AVIADORES DEL CHACO, 2050 EDIF. WORLD TRADE CENTER, TORRE 4 PISO 14 - BARRIO YKUA SATI";
      this.representative.AddressDriverRepresentative = "AV. AVIADORES DEL CHACO, 2050 EDIF. WORLD TRADE CENTER, TORRE 4 PISO 14 - BARRIO YKUA SATI";
    }
    console.log('Dirección Fiscal', this.representative.FiscalAddressRepresentative);
  }

  // INSERT
  save() {
    console.log(this.client.clientCategory);
    this.loading = true;
    this.isDisabled = true;
    this.client.clientStatus = 1;
    this.client.clientDeleted = 0;

    this.representative.CodeRepresentative == undefined ? this.representative.CodeRepresentative = "" : '';
    this.representative.StatusRepresentative = 1;
    this.representative.NameRepresentative == undefined ? this.representative.NameRepresentative = "" : '';
    this.representative.NationalityRepresentative == undefined ? this.representative.NationalityRepresentative = "PARAGUAYO" : '';
    this.representative.NumberIdRepresentative == undefined ? this.representative.NumberIdRepresentative = "0" : '';
    this.representative.FiscalAddressRepresentative == undefined ? this.representative.FiscalAddressRepresentative = "CIUDAD" : '';
    this.representative.AddressDriverRepresentative == undefined ? this.representative.AddressDriverRepresentative = "CIUDAD" : '';
    this.representative.TypeVehicle == undefined ? this.representative.TypeVehicle = "VEHICULO" : '';
    this.representative.BrandVehicle == undefined ? this.representative.BrandVehicle = "" : '';
    this.representative.AdditionalVehicle == undefined ? this.representative.AdditionalVehicle = "ARGO" : '';
    this.representative.NumberIdVehicle == undefined ? this.representative.NumberIdVehicle = "0" : '';
    this.representative.ModelVehicle == undefined ? this.representative.ModelVehicle = "0" : '';

    console.log('Representante', this.representative);

    if(this.representative.CodeRepresentative == undefined || this.representative.CodeRepresentative.trim() === '') {
      // Generar código de representante automáticamente: 4 primeras letras del nombre + 4 dígitos aleatorios
      const name = (this.representative.NameRepresentative || '').replace(/\s+/g, '').toUpperCase();
      const prefix = name.substring(0, 4).padEnd(4, 'X');
      const randomNum = Math.floor(1000 + Math.random() * 9000); // 4 dígitos aleatorios
      this.representative.CodeRepresentative = `${prefix}${randomNum}`;
      // return;
    }

    // Validar que ningún dato de representative esté en blanco
    for (const [key, value] of Object.entries(this.representative)) {
      if (value === undefined || value === null || value.toString().trim() === "") {
      this._utilsService.showNotification(3, `El campo "${key}" de Representante es obligatorio.`);
      this.isDisabled = false;
      this.loading = false;
      return;
      }
    }    

    this._representativeService.insert(this.representative).then(
      (response) => {
        if (response.result == true) {
          this._utilsService.showNotification(1, response.message);
          this.cleanModel();
        } else {
          this._utilsService.showNotification(3, response.errorMessage);
        }
      },
      (error) => {
        this._utilsService.showNotification(2, error);
      }
    ).finally(() => {
      this.isDisabled = false;
      this.loading = false;
    });             
  }

  // UPDATE
  update() {
    this.loading = true;
    this.isDisabled = true;

    // this.client.clientCredit ? this.client.clientCredit = 1 : this.client.clientCredit = 0;
    // this.client.clientBlocked ? this.client.clientBlocked = 1 : this.client.clientBlocked = 0;
    // this.client.clientAddressFrequent == undefined ? this.client.clientAddressFrequent = "0000-0000" : '';
    // this.client.clientPhone2 == undefined ? this.client.clientPhone2 = "0000-0000" : '';
    // console.log(this.client);

    this.representative.CodeRepresentative == undefined ? this.representative.CodeRepresentative = "" : '';
    // this.representative.StatusRepresentative = 1;
    this.representative.StatusRepresentative ? this.representative.StatusRepresentative = 1 : this.representative.StatusRepresentative = 0;
    this.representative.NameRepresentative == undefined ? this.representative.NameRepresentative = "" : '';
    this.representative.NationalityRepresentative == undefined ? this.representative.NationalityRepresentative = "PARAGUAYO" : '';
    this.representative.NumberIdRepresentative == undefined ? this.representative.NumberIdRepresentative = "0" : '';
    this.representative.FiscalAddressRepresentative == undefined ? this.representative.FiscalAddressRepresentative = "CIUDAD" : '';
    this.representative.AddressDriverRepresentative == undefined ? this.representative.AddressDriverRepresentative = "CIUDAD" : '';
    this.representative.TypeVehicle == undefined ? this.representative.TypeVehicle = "VEHICULO" : '';
    this.representative.BrandVehicle == undefined ? this.representative.BrandVehicle = "" : '';
    this.representative.AdditionalVehicle == undefined ? this.representative.AdditionalVehicle = "ARGO" : '';
    this.representative.NumberIdVehicle == undefined ? this.representative.NumberIdVehicle = "0" : '';
    // this.representative.ModelVehicle == undefined ? this.representative.ModelVechicle = "0" : '';
    this.representative.ModelVechicle == undefined ? this.representative.ModelVechicle = "0" : '';

    console.log('Representante', this.representative);

    this._representativeService.update(this.representative).then(
      async (response) => {
        if (response.result == true) {
          this.isEdit = false;
          this.companyCode === 1 ? this.getAll() : this.getAllByCompany();
          this.cleanModel();
          this._utilsService.showNotification(1, response.message);
        } else {
          this._utilsService.showNotification(3, response.errorMessage);
        }
      },
      error => {
        console.log(error);
        this._utilsService.showNotification(2, error);
      }
    ).finally(() => {
      this.loading = false;
      this.isDisabled = false;
    });
  }

  // DELETED
  deleteFunction($event) {
    $event.preventDefault();

    // this.client.clientCode = this.activeRow.clientCode;
    // this.client.clientStatus = 0;
    // this.client.clientDeleted = 1;

    console.log('Active Row', this.activeRow);

    this.representative = Object.assign({}, this.activeRow);
    this.representative.ModelVehicle == this.activeRow.ModelVechicle;
    this.representative.StatusRepresentative = 0;

    swal.fire({
      title: "Esta seguro",
      text: "El representante se eliminara definitivamte!",
      icon: "warning",
      showCancelButton: true,
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      confirmButtonText: "Si, eliminar!",
      buttonsStyling: false
    }).then(result => {
      if (result.value) {
        this.update();
        swal.fire({
          title: "Enviado!",
          text: "Se ha mandado la solicitud.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-success",
          },
          buttonsStyling: false
        });
      }
    });
  }

  // LOAD DATA TO EDIT
  editFunction($event) {
    $event.preventDefault();
    this.isEdit = true;
    
    // this.client.clientCode = this.activeRow.clientCode;
    // this.client.clientCompanyCode = this.activeRow.clientCompanyCode;
    // this.client.clientBussinesCode = this.activeRow.clientBussinesCode;
    // this.client.clientName = this.activeRow.clientName;
    // this.client.clientTaxDocument = this.activeRow.clientTaxDocument;
    // this.client.clientEmail = this.activeRow.clientEmail;
    // this.client.clientPhone = this.activeRow.clientPhone;
    // this.client.clientPhone2 = this.activeRow.clientPhone2;
    // this.client.clientAddress = this.activeRow.clientAddress;
    // this.client.clientAddressFrequent = this.activeRow.clientAddressFrequent;
    // this.client.clientCategory = this.activeRow.clientCategory;
    // this.client.clientCreditTime = this.activeRow.clientCreditTime;
    // this.client.clientCreditAmount = this.activeRow.clientCreditAmount;
    // this.client.clientBlocked = this.activeRow.clientBlocked;
    // this.client.clientType = this.activeRow.clientType;
    // this.client.clientNameFrequent = this.activeRow.clientNameFrequent;

    // this.activeRow.clientCredit == 1 ? this.client.clientCredit = true : this.client.clientCredit = false;
    // this.activeRow.clientBlocked == 1 ? this.client.clientBlocked = true : this.client.clientBlocked = false;

    console.log('Active Row', this.activeRow);

    this.representative = Object.assign({}, this.activeRow);
    this.representative.ModelVehicle == this.activeRow.ModelVechicle;
    // this.representative.CodeRepresentative == undefined ? this.representative.CodeRepresentative = "" : '';
    // this.representative.StatusRepresentative = 1;
    // this.representative.NameRepresentative == undefined ? this.representative.NameRepresentative = "" : '';
    // this.representative.NationalityRepresentative == undefined ? this.representative.NationalityRepresentative = "PARAGUAYO" : '';
    // this.representative.NumberIdRepresentative == undefined ? this.representative.NumberIdRepresentative = "0" : '';
    // this.representative.FiscalAddressRepresentative == undefined ? this.representative.FiscalAddressRepresentative = "CIUDAD" : '';
    // this.representative.AddressDriverRepresentative == undefined ? this.representative.AddressDriverRepresentative = "CIUDAD" : '';
    // this.representative.TypeVehicle == undefined ? this.representative.TypeVehicle = "TERRESTRE" : '';
    // this.representative.BrandVehicle == undefined ? this.representative.BrandVehicle = "" : '';
    // this.representative.AdditionalVehicle == undefined ? this.representative.AdditionalVehicle = "ARGO" : '';
    // this.representative.NumberIdVehicle == undefined ? this.representative.NumberIdVehicle = "0" : '';
    // this.representative.ModelVehicle == undefined ? this.representative.ModelVehicle = "0" : '';
    // this.representative.ModelVechicle == undefined ? this.representative.ModelVechicle = "0" : '';

    console.log('Representante', this.representative);

    // const _selectedItem = this.categoryList.find(x => x.id == this.activeRow.clientCategory);
    // this.getSelectSetting(_selectedItem);
  }

  billing($event) {
    $event.preventDefault();
    swal.fire({
      title: 'Nota',
      text: "Se abrira una pestaña nueva",
      icon: "warning",
      width: 750,
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: 'Factura Normal',
      denyButtonText: 'Fatura Cambiaria',
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-success",
        denyButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
    }).then((result) => {
      if (result.isDismissed) {
        //console.log('candelado')
        console.log(this.company);
        console.log('activeRow Client',this.activeRow);        
      } else {
        let billingType;        
        this.company.companyInvoiceType == 1 ? billingType = 'inventory' : billingType = 'description';

        localStorage.setItem(
          "clientData",
          JSON.stringify(this.activeRow)
        );

        if (result.isConfirmed) {
          window.open(this.url + billingType + '-billing?nit=' + this.activeRow.nit);
        } else if (result.isDenied) {
          window.open(this.url + billingType + '-exchange-note?nit=' + this.activeRow.nit);
        }
      }
    })
  }

  //BILLING CLIENT
  // billing($event) {
  //   $event.preventDefault();
  //   let billingType;
  //   this.company.companyInvoiceType == 1 ? billingType = 'inventory' : billingType = 'description';
  //   window.open(this.url + billingType + '-billing?nit=' + this.activeRow.nit);
  // }

  ///////////////////////COMPLEMENT///////////////////////
  creditFunction() {
    this.client.clientCredit == true ? this.noCredit = false : this.noCredit = true;
    this.client.clientInterest = null;
    this.client.clientCreditTime = null;
    this.client.clientCreditAmount = null;
  }

  //CANCEL EDIT
  cancelUpdate($event) {
    this.cleanModel();
    this.isEdit = false;
  }

  // CLEAR MODAL
  cleanModel() {
    this.isDisabled = false;
    this.representative = {} as Representative;

    this.representative.TypeVehicle = "VEHICULO";
    this.representative.AdditionalVehicle = "ARGO";
    this.representative.NationalityRepresentative = "PARAGUAYO";
    this.client.clientTR = "0";
    
    this.isEdit = false;
    this.noCredit = true;
    this.isDisabled = false;
    this.getAll();
  }

  // DESCARGAR EXCEL
  async downloadToExcel() {
    const checkList = this.temp;
    const exportFile = new Array<any>();

    checkList.forEach(element => {
      let json = {};
      Object.keys(this.settings.columns).forEach((item, index, arr) => {
        if (this.settings.columns[item].type === "number") {
          json[this.settings.columns[item].title] = parseFloat(element[item]);
        } else {
          json[this.settings.columns[item].title] = element[item];
        }
      });
      exportFile.push(json);
    });
    const ws: xlsx.WorkSheet =
      xlsx.utils.json_to_sheet(exportFile);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Reporte');
    xlsx.writeFile(wb, 'reporte-cliente.xlsx');
  }
}
